export default __webpack_public_path__ + "static/media/missed_calls.eb329195.svg";